import { APIGATEWAY_BASE_URL } from 'src/dataLayer/env'

import makeAjaxRequest from '../makeAjaxRequest'

export const ERROR_KEYS = {
  400: {
    key: 'common.error.unknown',
  },
  401: {
    key: 'email.error.expired_token',
  },
  422: {
    key: 'email.error.invalid_email_format',
  },
  default: {
    key: 'common.error.unknown',
  },
}

export default ({ email, locale }) =>
  makeAjaxRequest({
    errorKeys: ERROR_KEYS,
    payload: { session: { email } },
    url: `${APIGATEWAY_BASE_URL}/v1.0.0/${locale}/authentication/session`,
    verb: 'POST',
  }).then(({ session: { captcha, code } }) => ({
    captchaConfig: Object.keys(captcha).length === 0 ? null : captcha,
    sessionCode: code,
  }))
